module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/twitter-48cd0fe82b5dea243197e99ea84a67fe.svg";